import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-send-message',
  templateUrl: './icon-send-message.component.html',
  styleUrls: ['./icon-send-message.component.scss']
})
export class IconSendMessageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
